import { EligibilityCase } from 'utils/medicareSupEligibility';

export function medSuppSlug(eligibilityCase: EligibilityCase): string {
  switch (eligibilityCase) {
    case 'inIEP':
      return 'iibi';
    case 'inIEPAEP':
      return 'two';
    case 'inSEP':
      return 'ciesep';
    case 'inAEP':
      return 'in-aep';
    case 'inMAOEP':
      return 'in-ma-oep';
    case 'inGEPSEP':
      return 'in-gep-sep';
    case 'in6MWMS':
      return '6mw-ms';
    case 'inSWMSNYR':
      return 'sw-ms-nyr';
    case 'inSWMSYR':
      return 'sw-ms-yr';
    default:
      return 'uet';
  }
}
